/**
* position: 'top-start', 'top-center', 'top-end', 'middle-start', 'middle-center', 'middle-end', 'bottom-start', 'bottom-center', 'bottom-end'
* varitions: 'primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark'
*/
import React, { createContext, useContext, useState } from 'react';

// Crear el contexto
const ToastContext = createContext();

// Proveedor del contexto para envolver tu aplicación
export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]); // Estado de los toasts

  // Función para agregar un toast
  const addToast = (newToast) => {
    setToasts((prevToasts) => [...prevToasts, newToast]);
  };

  // Función para cerrar un toast
  const closeToast = (id) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  };

  return (
    <ToastContext.Provider value={{ toasts, addToast, closeToast }}>
      {children}
    </ToastContext.Provider>
  );
};

// Crear un custom hook para consumir el contexto
export const useToast = () => {
  return useContext(ToastContext);
};
